export enum BioSampleFlowType {
  COLLECT = 'COLLECT',
  PROCESS = 'PROCESS',
  SHIP = 'SHIP',
  MULTI_ALIQUOT = 'MULTI_ALIQUOT',
  ALIQUOT = 'ALIQUOT',
}
